module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.getClientKycList.length) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.KycNoFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.clientTypeFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.KycNoFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.clientTypeFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getClientKycList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getClientKycList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isClientKycDash) ? _c('b-button', {
    staticClass: "pull-right mt-1",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addClientKyc('add', '')
      }
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), _c('ClientCard'), _vm._v(" "), (
    (_vm.$sessionsStorage.get('designation') == 'Admin' ||
      _vm.$sessionsStorage.get('designation') == 'HOD') &&
    !_vm.isClientKycDash
  ) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.GoKycClient()
      }
    }
  }, [_vm._v("Go To Client")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientTypes,
      "option-value": "clientTypeVal",
      "option-text": "clientTypeText",
      "placeholder": "Select Shipper Name"
    },
    on: {
      "input": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientTypeFilter", $$v)
      },
      expression: "Filter.clientTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Client Name Filter",
      "id": "clientFilter",
      "name": "clientFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Kyc No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Kyc No Filter",
      "id": "KycNoFilter",
      "name": "KycNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.KycNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "KycNoFilter", $$v)
      },
      expression: "Filter.KycNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getClientKycTempList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.isClientKycDash) ? _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getClientKycList,
      "fields": _vm.PrerequisiteFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "kyc_no",
      fn: function(row1) {
        return [_c('span', [_vm._v("Client Kyc No : " + _vm._s(row1.item.kyc_no))]), _vm._v(" "), _c('span', [_vm._v("TAN No : " + _vm._s(row1.item.tan))])]
      }
    }, {
      key: "client_doc",
      fn: function(row1) {
        return [(row1.item.client_doc) ? _c('div', _vm._l((row1.item.client_doc.split(',')), function(item1, index) {
          return _c('b-button', {
            key: index,
            staticClass: "mb-1",
            staticStyle: {
              "margin-left": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "warning"
            },
            on: {
              "click": function($event) {
                item1 ? _vm.PrintValidity_Doc(item1) : ''
              }
            }
          }, [_vm._v(_vm._s(item1 ? "PDF" + (parseInt(index) + 1) : ""))])
        })) : _vm._e()]
      }
    }, {
      key: "raisedBy",
      fn: function(row3) {
        return [(row3.item.raisedBy) ? _c('span', [_vm._v("Raised By : " + _vm._s(row3.item.raisedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.create_date) ? _c('span', [_vm._v("Created Date : " + _vm._s(row3.item.create_date)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updatedBy) ? _c('span', [_vm._v("Updated By : " + _vm._s(row3.item.updatedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.update_date) ? _c('span', [_vm._v("Updated Date : " + _vm._s(row3.item.update_date)), _c('br')]) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.addClientKyc('edit', row3.item)
            }
          }
        }, [_vm._v(_vm._s(row3.item.client_kyc_is_converted === "1" ? "View" : "Edit"))]), _vm._v(" "), (
          (_vm.$sessionsStorage.get('designation') == 'Admin' ||
            _vm.$sessionsStorage.get('designation') == 'HOD') &&
          !_vm.isClientKycDash &&
          row3.item.client_kyc_is_converted == 0
        ) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.ConvertKycClient(row3.item)
            }
          }
        }, [_vm._v("Convert To Client")]) : _vm._e()]
      }
    }])
  })], 1) : (_vm.isClientKycDash) ? _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getClientKycList,
      "fields": _vm.ClientKYCDashFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "client_name",
      fn: function(row1) {
        return [_c('span', [_vm._v("Client Name : " + _vm._s(row1.item.client_name))]), _c('br'), _vm._v(" "), (_vm.isClientKycDash) ? _c('span', [_vm._v("TAN : " + _vm._s(row1.item.tan))]) : _vm._e()]
      }
    }, {
      key: "kyc_no",
      fn: function(row1) {
        return [_c('span', [_vm._v("Client Kyc No : " + _vm._s(row1.item.kyc_no))])]
      }
    }, {
      key: "kam_name",
      fn: function(row1) {
        return [_c('span', [_vm._v("Name : " + _vm._s(row1.item.kam_name)), _c('br')]), _vm._v(" "), (_vm.isClientKycDash) ? _c('span', [_vm._v("Email : " + _vm._s(row1.item.kam_email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isClientKycDash) ? _c('span', [_vm._v("Mobile : " + _vm._s(row1.item.kam_mobile)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isClientKycDash) ? _c('span', [_vm._v("Designation : " + _vm._s(row1.item.kam_designation))]) : _vm._e()]
      }
    }, {
      key: "quest_export_import",
      fn: function(row1) {
        return [(_vm.isClientKycDash) ? _c('span', [_vm._v("Deal Type : " + _vm._s(row1.item.quest_export_import))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.isClientKycDash) ? _c('span', [_vm._v("CC :\n                  " + _vm._s(row1.item.quest_cc == "1" ?
          "YES" :
          row1.item.quest_cc == "0" ?
          "No" :
          "NA"))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.isClientKycDash) ? _c('span', [_vm._v("FF :\n                  " + _vm._s(row1.item.quest_ff == "1" ?
          "YES" :
          row1.item.quest_ff == "0" ?
          "No" :
          "NA"))]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.quest_ff == '1' && _vm.isClientKycDash) ? _c('span', [_vm._v("Container Type : " + _vm._s(row1.item.containerType))]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.quest_ff == '1' && _vm.isClientKycDash) ? _c('span', [_vm._v("Volume : " + _vm._s(row1.item.quest_monthly_volume))]) : _vm._e(), _vm._v(" "), (row1.item.quest_ff == '1' && _vm.isClientKycDash) ? _c('span', [_vm._v("NOMINATION SHIPPER : " + _vm._s(row1.item.nominationShipperStatus))]) : _vm._e(), _vm._v(" "), (row1.item.quest_ff == '0' && _vm.isClientKycDash) ? _c('span', [_vm._v("FF NA Reason :\n                  " + _vm._s(row1.item.quest_ff_option == "0" ?
          "NOMINATION SHIPPER" :
          row1.item.quest_ff_option == "1" ?
          "ALL NOMINATION" :
          row1.item.quest_ff_option == 2 ?
          "ALL DIRECT SLINE CONTRACTS" :
          "NA"))]) : _vm._e()]
      }
    }, {
      key: "client_doc",
      fn: function(row1) {
        return [(row1.item.client_doc) ? _c('div', _vm._l((row1.item.client_doc.split(',')), function(item1, index) {
          return _c('b-button', {
            key: index,
            staticClass: "mb-1",
            staticStyle: {
              "margin-left": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "warning"
            },
            on: {
              "click": function($event) {
                item1 ? _vm.PrintValidity_Doc(item1) : ''
              }
            }
          }, [_vm._v(_vm._s(item1 ? "PDF" + (parseInt(index) + 1) : ""))])
        })) : _vm._e()]
      }
    }, {
      key: "raisedBy",
      fn: function(row3) {
        return [(row3.item.raisedBy) ? _c('span', [_vm._v("Raised By : " + _vm._s(row3.item.raisedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.create_date) ? _c('span', [_vm._v("Created Date : " + _vm._s(row3.item.create_date)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updatedBy) ? _c('span', [_vm._v("Updated By : " + _vm._s(row3.item.updatedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.update_date) ? _c('span', [_vm._v("Updated Date : " + _vm._s(row3.item.update_date)), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isClientKycDash) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.addClientKyc('edit', row3.item)
            }
          }
        }, [_vm._v(_vm._s(row3.item.client_kyc_is_converted === "1" ? "View" : "Edit"))]) : _vm._e(), _vm._v(" "), (row3.item.client_kyc_is_converted == 0 && !_vm.isClientKycDash) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.ConvertKycClient(row3.item)
            }
          }
        }, [_vm._v("Convert To Client")]) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa6d726","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientKycTemp/ClientKycList.vue
// module id = 2716
// module chunks = 0